import { FC } from "react";
import { Box, Select, MenuItem, Tooltip } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { IBateriaVirtual, VirtualBatteryJoinTypes } from './types/virtualBattery';
import { useVirtualBatteries } from "./hooks/useVirtualBatteries";
import { useTranslation } from "react-i18next";
import useAuth from "@/components/Authentication/hooks/useAuth";

export interface IVirtualBatteryDiscountSelectProps {
  bateriaVirtual: IBateriaVirtual
}

const VirtualBatteryDiscountSelect: FC<IVirtualBatteryDiscountSelectProps> = ({
  bateriaVirtual
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { tokenVals } = useAuth();

  const { 
    virtualBatteryTypes,
    handleBatteryTypeChange,
  } = useVirtualBatteries();

  return (
    <Box>
      <Tooltip
        title={tokenVals?.readonly &&
          t("common:text.token_readonly_tooltip")
        }
        placement="right"
        arrow
        disableFocusListener={!tokenVals?.readonly}
        disableHoverListener={!tokenVals?.readonly}
        disableTouchListener={!tokenVals?.readonly}
        slotProps={{
          popper: {
            modifiers: [{
              name: 'offset',
              options: {offset: [0, -5]}
            }]
          }
        }}
      >
        <Select
          disabled={!!tokenVals?.readonly}
          sx={{ 
            [theme.breakpoints.down("md")]: {
              width: '74vw'
            }
          }}
          value={bateriaVirtual.gestio_descomptes}
          onChange={(event) => {
            handleBatteryTypeChange(
              event.target.value as VirtualBatteryJoinTypes, 
              bateriaVirtual.id
            );
          }}
        >
          {virtualBatteryTypes?.map((p) => {
            return <MenuItem 
              key={p.name} 
              value={p.name}
            >
              {p.description}
            </MenuItem>
          })}
        </Select>
      </Tooltip>
    </Box>
  );
};

export default VirtualBatteryDiscountSelect;
